<script setup lang="ts">
import { Button } from "@/components/ui/button";

interface Props {
  currentPage: number;
  totalPages: number;
  canGoPrev: boolean;
  canGoNext: boolean;
  loading: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  prev: [];
  next: [];
}>();
</script>

<template>
  <div class="flex items-center justify-center gap-4 py-4 min-h-[52px]">
    <template v-if="!loading && totalPages > 1">
      <Button
        @click="emit('prev')"
        :disabled="!canGoPrev"
        variant="outline"
        class="px-6"
      >
        Previous
      </Button>

      <span class="text-sm text-muted-foreground whitespace-nowrap">
        Page {{ currentPage }} of {{ totalPages }}
      </span>

      <Button
        @click="emit('next')"
        :disabled="!canGoNext"
        variant="outline"
        class="px-6"
      >
        Next
      </Button>
    </template>
  </div>
</template>
